export function renderResumeFilename(user) {
    const tempName = user.applicantName || ""
    const experience = user.experience
    const safeName = (tempName).replace(
        /[<>:"/\\|?*.]/g,
        ""
    )
    const expLabel =
        experience?.year || experience?.month
            ? `[${experience.year || 0}y ${experience.month || 0}m]`
            : "[_Resume]";
    const baseName = `SAN_${safeName}${expLabel}`;

    if(user.resumeLink){
        const extMatch = user.resumeLink.match(/\.(\w+)$/);
        const ext = extMatch ? `.${extMatch[1]}` : ".pdf";

        if (extMatch && ext) return `${baseName}${ext}`
    }
    return `${baseName}.pdf`
}